import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import PublicationViewer from '../components/PublicationViewer';

const PublicPublicationView = () => {
  const { id } = useParams();
  const [publication, setPublication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPublication();
  }, [id]);

  const fetchPublication = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/publications/${id}`);

      // Check if publication is published
      if (!response.data.isPublished) {
        setError('This publication is not available');
        setLoading(false);
        return;
      }

      setPublication(response.data);
    } catch (error) {
      setError('Failed to load publication');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <div className="text-gray-600 text-lg">Loading publication...</div>
      </div>
    );
  }

  if (error || !publication) {
    return (
      <div className="flex flex-col justify-center items-center h-screen bg-gray-100">
        <div className="text-red-600 text-lg mb-4">{error || 'Publication not found'}</div>
        <p className="text-gray-600">
          This publication may have been removed or is not yet published.
        </p>
      </div>
    );
  }

  return (
    <div>
      <PublicationViewer publicationId={id} token={null} />
    </div>
  );
};

export default PublicPublicationView;
